import { fetchWorkReports } from './effects';
import { $workReports } from './states';

// Fetch work reports
$workReports.on(fetchWorkReports.doneData, (_, data) => data);
